import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AnimeContextProvider } from './context/animeContent';
import { DarkModeContextProvider } from "./context/darkModeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnimeContextProvider>
    <DarkModeContextProvider>
    <App />
    </DarkModeContextProvider>
    </AnimeContextProvider>
  </React.StrictMode>
);
